import { MonthlyUsageModel } from '@models/usageModels/MonthlyUsageModel';
import { KEYS, repository } from '@repositories/Repository';
import IMonthlyUsageRepository from '@repositories/usage/monthlyUsageRepository/IMonthlyUsageRepository';
import { MonthlyFilters } from '@repositories/usage/Types';
import { useQuery } from '@tanstack/react-query';
import { Page } from '@type/Page';
import { AxiosError } from 'axios';
import { UseQueryOptionsType } from './UseQueryOptionsType';

const monthlyUsageRepo = repository.get<IMonthlyUsageRepository>(KEYS.MONTHLY_USAGE_REPOSITORY);

const monthlyUsageKey = {
  all: ['Monthly'] as const,
  lists: () => [...monthlyUsageKey.all, 'list'] as const,
  list: (filter?: MonthlyFilters) => [...monthlyUsageKey.lists(), { filter }] as const,
};

export const useGetMonthlyUsages = (queries?: MonthlyFilters, options?: UseQueryOptionsType<Page<MonthlyUsageModel>>) =>
  useQuery<Page<MonthlyUsageModel>, AxiosError>({
    queryKey: monthlyUsageKey.list(queries),
    queryFn: async () => {
      const result = await monthlyUsageRepo.getList(queries);
      return { ...result, content: result.content.map(monthly => new MonthlyUsageModel(monthly)) };
    },
    ...options,
    cacheTime: 5 * 60 * 1000,
    staleTime: 4 * 60 * 1000,
  });
